var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { TableBodyCell } from '@pocketlaw/tetris';
import { Link } from 'react-router-dom';
import { getSearchEntityLink, getSearchHighlightContext, HtmlStringToReact, } from 'app/domains/global-search';
import { TypeAvatarWithLabel } from 'shared/domains/common-ui';
import { entityTypeToAvatarType } from './utils';
import { TITLE_CELL_WIDTH } from '../../consts';
export function TitleCell(props) {
    const { type, entityId, name, highlight } = props, rest = __rest(props, ["type", "entityId", "name", "highlight"]);
    const to = getSearchEntityLink(type, entityId);
    const { highlightText, showNameOnly } = getSearchHighlightContext(name, highlight);
    const avatarType = entityTypeToAvatarType(type);
    // NOTE: The underlying component doesn't accept ReactNode as a prop.
    // This has to be fixed, somehow. Sometime
    const highlightMarkup = (<HtmlStringToReact allowedTags={['mark']} text={highlightText}/>);
    return (<TableBodyCell maxWidth={TITLE_CELL_WIDTH} {...rest}>
      <Link to={to}>
        <TypeAvatarWithLabel truncate type={avatarType} title={showNameOnly ? highlightMarkup : name} subtitle={showNameOnly ? undefined : highlightMarkup}/>
      </Link>
    </TableBodyCell>);
}
